import script from "./DeletePhoneNumberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletePhoneNumberModal.vue?vue&type=script&setup=true&lang=js"

import "./DeletePhoneNumberModal.vue?vue&type=style&index=0&id=4bc655ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc655ab"]])

export default __exports__